import { Event } from '../events'
import { EventTracker } from './EventTracker'
import TrackingClient from '../TrackingClient'
import { ViewerContext } from '../constants'

function displayNameForViewerContext(identity: ViewerContext): string {
  switch (identity) {
    case ViewerContext.Consumer:
      return 'consumer'
    case ViewerContext.BusinessUser:
      return 'business user'
    case ViewerContext.PartnerUser:
      return 'partner user'
    case ViewerContext.Operator:
      return 'operator'
  }
}

/**
 * An EventTracker that authorizes each event against the tracked user's identity type,
 *   and ensures the client has not disabled tracking entirely.
 *
 * A warning is logged if an event is tracked by a user with an invalid identity type.
 */
export default class AuthorizingEventTracker extends EventTracker {
  private client: TrackingClient
  private tracker: EventTracker

  public constructor(client: TrackingClient, tracker: EventTracker) {
    super()

    this.client = client
    this.tracker = tracker

    EventTracker.getEventTrackingMethodNames().map((eventTrackingMethodName) => {
      this[eventTrackingMethodName] = (event: Event<any>) => {
        if (client.disabled) {
          return
        }

        if (event.allowedViewerContexts.includes(this.client.viewerContext)) {
          this.tracker[eventTrackingMethodName](event as any)
        } else {
          console.warn(
            `Can not track "${event.displayName}" as a ${displayNameForViewerContext(
              this.client.viewerContext
            )}. Allowed identities for this event are: ${event.allowedViewerContexts
              .map((viewerContext) => `"${displayNameForViewerContext(viewerContext)}"`)
              .join(', ')}`
          )
        }
      }
    })
  }
}
